export enum ReasonForDelayId {
  // Parent + principal signature required
  ParentAndPrincipal = 1,

  // Final‑notice & withdrawal cases
  FinalNoticeReferredElsewhere = 2,
  FinalNoticeLackOfConsent = 3,
  FinalNoticeStudentMoved = 4,
  PhoneOutreach = 5, // special: phone + withdrawal

  // Same as 2‑4 (final notice) but different UI flag
  FinalNoticeIEPEnded = 6,

  // Placement‑related
  PlacementSignature = 7,
  Placement45DayOutreach = 8,

  // Revocation
  RevocationConsentElapsed = 9,

  // Ineligibility
  IneligibilityLetterPWN = 10,

  // Declassification
  Declassification = 11,

  // Discharge
  Discharge = 12,
}
